import { define } from 'wicked-elements'
import autosize from 'autosize'

define('[data-component~="auto-textarea"]', {
  connected () {
    autosize(this.element)
  },
  disconnected () {
    autosize.destroy(this.element)
  }
})